/**
 * Utah's words for playbooks.ts: the Utah parts of the menu playbooks' citations (home kitchen statute, R392-102 truck rule,
 * R392-100-4 amendment) and of the stage lines. Data only.
 */
export const PLAYBOOKS_UT = {
  cites: {
    /** Home kitchens (microenterprise): the statute section that lists the milk a home kitchen may sell. */
    mehkMilkSale: "Utah Code 26B-7-416(9)(w)",
    /** Home kitchens: the statute section on records and 72-hour holding. */
    mehkRecords: "Utah Code 26B-7-416(8)(a)",
    /** Receiving shell eggs: the state amendment to Food Code 3-202.13 (45°F air). */
    eggAmended: "R392-100-4(3)(e) (Food Code 3-202.13 as amended in Utah)",
    /** Storing shell eggs: the same state amendment, cited short. */
    eggStorageRule: "R392-100-4(3)(e)",
    /** Receiving ground beef: whose inspection counts besides USDA's (the state's own meat inspection). */
    inspectedMeat: "USDA- or Utah-inspected",
    /** Food trucks: the truck rule on receiving food. */
    truckReceiving: "R392-102-12(1)",
    /** Food trucks: the truck rule on cooling (only at the commissary). */
    truckCooling: "R392-102-12(5)",
    /** Food trucks: the truck rule on hot holding. */
    truckHotHolding: "R392-102-12(6)",
    /** Food trucks: the truck rule that bars specialized processes (smoking to preserve, curing, ROP). */
    truckSpecialProcess: "R392-102-11(22)(a)",
  },
  /** Stage 2: the statute behind the food handler clock (course within 14 days, permit within 30). */
  foodHandlerCite: "Utah Code 26B-7-413(2)",
  /** Stage 3: which rule food trucks run under and who honors the permit. */
  truckRuleNote: "Trucks run under R392-102, not R392-100; one county permit is honored statewide.",
  /** Stage 3: the truck rules, statute and fire checklist the equipment and staffing lines come from. */
  truckSources: ["R392-100-3(1)(a), (2)", "R392-102-3, -4, -6, -7, -8, -15", "Utah Code 11-56-104", "R710-14-5; State Fire Marshal food truck checklist", "docs/source/research/food-truck-utah.md"],
} as const;
